import React from 'react';
// import env from "react-dotenv";
import PageHeader from 'components/common/PageHeader'
import { SelezionaQuestionario } from './SelezionaQuestionario'
import { SelezionaQuestionarioAzienda } from './SelezionaQuestionarioAzienda'
import { unsetQuestionarioMenu } from '../reduxStore/siteMapsSlice'
import { useDispatch, useSelector } from 'react-redux'

//import { setPartnerPannelloEtQuestionario} from '../reduxStore/menuConfigSlice'
import { setMaster, setPartnerSoloPannello, setAzienda } from '../reduxStore/menuConfigSlice'


const GeneralHome = () => {
  const csvcRole = useSelector((state) => state.utenteCorrente.csvcRole);

  const dispatch = useDispatch();
  dispatch(unsetQuestionarioMenu())

  dispatch(setAzienda())

  // console.log ("*** SONO IN General-Home. REACT_APP_PUBLIC_URL is: ", env.REACT_APP_PUBLIC_URL)
  // console.log ("*** SONO IN General-Home. REACT_APP_API_URL is: ", env.REACT_APP_API_URL)

  switch (csvcRole) {
      case 'partner':
        dispatch(setPartnerSoloPannello())
        return (
          <>
            <SelezionaQuestionario />
          </>
          );
      case 'azienda':
        dispatch(setAzienda())
        return (
          <>
           <SelezionaQuestionarioAzienda />
          </>
        );
      case 'master':
        dispatch(setMaster())
        return (
          <>
            <PageHeader
              title='Gestione partner'
              description='in previsione'
              className="mb-3"
            >
            </PageHeader>
          </>
          );
      default:
        dispatch(setAzienda())
        return (<p>Ruolo non definito</p>);
 } 

};

export default GeneralHome;
